<app-title-pages-component [pageData]="pageData()"></app-title-pages-component>
<div class="container">
  <form [formGroup]="formUser" (ngSubmit)="onSubmit()">

    <!-- Razón social -->
    <div class="form-row">
      <div class="input-container span-2">
        <input id="name" type="text" class="form-control" formControlName="name" required
               [ngClass]="{ 'filled': formUser.get('name')?.value}"/>
        <label for="name">{{ clientsFormComponent()?.companyNameLabel }}</label>

        @if (name?.invalid && (!name?.untouched || name?.dirty || submitted)) {
          <div class="alert alert-danger">
            @if (name?.hasError('required') || name?.hasError('soloEspacios')) {
              <span>
                {{ clientsFormComponent()?.corporateNameError }}
              </span>
            }
          </div>
        }
      </div>

      <!-- RFC -->
      <div class="input-container ">
        <input type="text" id="rfc" class="form-control" formControlName="rfc" required
               [ngClass]="{ 'filled': formUser.get('rfc')?.value}">
        <label for="businessName">{{ clientsFormComponent()?.rfcLabel }}</label>

        @if (rfc?.invalid && (!rfc?.untouched || rfc?.dirty || submitted)) {
          <div class="alert alert-danger">
            @if (rfc?.hasError('required')) {
              <span>
                {{ clientsFormComponent()?.rfcErrorRequired }}
              </span>
            }
            @if (rfc?.hasError('pattern')) {
              <span>{{ clientsFormComponent()?.rfcFormatError }}</span>
            }
          </div>
        }
      </div>
    </div>

    <div class="form-row">
      <!-- Nombre de la empresa -->
      <div class="input-container ">
        <input type="text" id="businessName" class="form-control" formControlName="businessName" required
               [ngClass]="{ 'filled': formUser.get('businessName')?.value}">
        <label for="businessName">{{ clientsFormComponent()?.corporateNameLabel }}</label>

      @if (businessName?.invalid && (!businessName?.untouched || businessName?.dirty || submitted)) {
        <div class="alert alert-danger">
          @if (businessName?.hasError('required') || businessName?.hasError('soloEspacios')) {
            <span>
              {{ clientsFormComponent()?.companyNameError }}
            </span>
          }
        </div>
      }
      </div>

      <!-- Domicilio fiscal -->
      <div class="input-container ">
        <input type="text" id="fiscalAddress" class="form-control" formControlName="fiscalAddress"
               [ngClass]="{ 'filled': formUser.get('fiscalAddress')?.value}">
        <label for="fiscalAddress">{{ clientsFormComponent()?.fiscalAddressLabel }}</label>
      </div>

      <!-- responsable de la campaña -->
      <div class="input-container ">
        <input type="text" id="contactName" class="form-control" formControlName="contactName"
               [ngClass]="{ 'filled': formUser.get('contactName')?.value}">
        <label for="contactName">{{ clientsFormComponent()?.campaignResponsibleLabel }}</label>
<!--        @if (contactName?.invalid && (!contactName?.untouched || contactName?.dirty || submitted)) {-->
<!--          <div class="alert alert-danger">-->
<!--            @if (contactName?.hasError('required') || contactName?.hasError('soloEspacios')) {-->
<!--              <span>-->
<!--                El responsable de la campaña es requerido y no puede estar vacío.-->
<!--              </span>-->
<!--            }-->
<!--          </div>-->
<!--        }-->
      </div>
    </div>

    <div class="form-row">
      <!-- Correo electrónico -->
      <div class="input-container ">
        <input type="email" id="contactEmail" class="form-control" formControlName="contactEmail"
               [ngClass]="{ 'filled': formUser.get('contactEmail')?.value}">
        <label for="contactEmail">{{ clientsFormComponent()?.emailLabel }}</label>

        @if (contactEmail?.invalid && (!contactEmail?.untouched || contactEmail?.dirty || submitted)) {
          <div class="alert alert-danger">
<!--            @if (contactEmail?.hasError('required')) {-->
<!--              <span>-->
<!--                El correo electrónico es requerido-->
<!--              </span>-->
<!--            }-->
            @if (contactEmail?.hasError('email')) {
              <span>{{ clientsFormComponent()?.emailFormatError }}</span>
            }
          </div>
        }
      </div>

      <!-- Teléfono de contacto -->
      <div class="input-container">
        <input type="tel" id="contactPhone" class="form-control" formControlName="contactPhone"
               [ngClass]="{ 'filled': formUser.get('contactPhone')?.value}">
        <label for="contactPhone">{{ clientsFormComponent()?.contactNumberLabel }}</label>
        @if (contactPhone?.invalid && (!contactPhone?.untouched || contactPhone?.dirty || submitted)) {
          <div class="alert alert-danger">
<!--            @if (contactPhone?.hasError('required')) {-->
<!--              <span>-->
<!--                El teléfono de contacto es requerido.-->
<!--              </span>-->
<!--            }-->
            @if (contactPhone?.hasError('pattern')) {
              <span>
                {{ clientsFormComponent()?.contactLengthError }}
              </span>
            }
          </div>
        }
      </div>
    </div>

    <div class="button-container">
      <button
        type="button"
        class="btn-cancel"
        (click)="onCancel()"
      >
        Cancelar
      </button>
      <button
        type="submit"
        [disabled]="formUser.invalid"
        [ngClass]="{
          'btn-disabled': formUser.invalid,
          'btn-enabled': formUser.valid
        }"
      >
        {{ isEditMode ? clientsFormComponent()?.updateButton : clientsFormComponent()?.saveButton }}
      </button>
    </div>
  </form>
</div>
